import { noop } from '../../../lib/utilities';
import { types as productTypes } from '../../_constants/product/types';
import { clickOnShowDetails, clickOnSeeAllAvailableVehicle } from '../../_modules/google_analytics/vehicle_personalised_page';
import {
    onOpenRegoLookupClick,
    onOpenVehicleConfiguratorClick,
    onOpenExtendedCmsSizeConfiguratorClick,
    onOpenTyreSizeConfiguratorClick,
    onOpenMotoTyreSizeConfiguratorClick,
    onOpenDefaultLayerConfigurator
}
    from '../../_views/configurator_buttons/configurator_buttons';
import initializeTargetComponent,
{ initializeConfiguratorComponents } from '../../_views/initialize_component';

export const initializePageModules = (tyreType, staticUrl) => {
    /**
     *
     * initialize lightbox components afterwards
     *
     */
    const options = { 'productType': tyreType, staticUrl };

    // Initialize GA for button click with ui-action-button__button class
    initializeTargetComponent(
        'a.ui-action-button__button:not(.vehicle_personalised_page):not(.all-available-tyre)',
        (e) => location.href = e,
        noop,
        noop,
        1,
    );
    
    // Initialize GA for click with vehicle_personalised_page class
    initializeTargetComponent(
        '.vehicle_personalised_page',
        (e) => location.href = e,
        clickOnShowDetails,
        noop,
        1,
        1,
    );
    
    // Initialize GA for click with all-available-tyre class
    initializeTargetComponent(
        '.all-available-tyre',
        (e) => location.href = e,
        clickOnSeeAllAvailableVehicle,
        noop,
        1,
        1,
    );
    
    // Initialize Catalog configurator component
    initializeTargetComponent(
        'a[href*="#open-main-configurator"]',
        initializeConfiguratorComponents.bind(this, options, true),
        onOpenDefaultLayerConfigurator,
        onOpenExtendedCmsSizeConfiguratorClick.bind(this, productTypes.TYRE_CAR)
    );
    
    initializeTargetComponent(
        'a[href*="#open-configurator"]',
        initializeConfiguratorComponents.bind(this, options, true),
        onOpenTyreSizeConfiguratorClick,
        onOpenExtendedCmsSizeConfiguratorClick.bind(this, productTypes.TYRE_CAR)
    );

    initializeTargetComponent(
        'a[href*="#open-moto-configurator"]',
        initializeConfiguratorComponents.bind(this, options, true),
        onOpenMotoTyreSizeConfiguratorClick,
        onOpenExtendedCmsSizeConfiguratorClick.bind(this, productTypes.TYRE_MOTO)
    );


    // Initialize Rego lookup 
    initializeTargetComponent(
        'a[href*="#open-rego-lookup"]',
        initializeConfiguratorComponents.bind(this, options, true),
        onOpenRegoLookupClick
    );

    initializeTargetComponent(
        'a[href*="#open-vehicle-configurator"]',
        initializeConfiguratorComponents.bind(this, options, true),
        onOpenVehicleConfiguratorClick
    );

};

